const textsForResources = {
  anchors: {
    title: "Import anchors from CSV",
    review: "Review anchors",
    imported: "anchors imported"
  },
  zones: {
    title: "Import zones from KML",
    review: "Review zones",
    imported: "zones imported"
  }
};

type Resource = keyof typeof textsForResources;
type Label = keyof (typeof textsForResources)[Resource];

export const getTextByLabelForResource = (resource: string | undefined, label: Label) => {
  if (!resource) throw new Error("Resource not found");

  const textsForResource = textsForResources[resource as Resource];

  if (!textsForResource) throw new Error(`Resource ${resource} not found`);

  return textsForResource[label];
};
